import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { CASES_ID_TYPES, casesIdTypeLocaleKey, type CasesIdType } from 'helpers/dashboardCases';
import useTranslate from 'hooks/useTranslate';

interface CasesIdTypeToggleProps {
    value: CasesIdType;
    onChange: (value: CasesIdType) => void;
}

export const CasesIdTypeToggle: React.FC<CasesIdTypeToggleProps> = ({ value, onChange }) => {
    const { translate } = useTranslate();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);

    return (
        <>
            <Button
                type="button"
                variant="text"
                size="small"
                aria-haspopup="menu"
                aria-expanded={open}
                endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 14 }} />}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setAnchorEl(event.currentTarget);
                }}
                sx={{
                    minWidth: 0,
                    px: 0.25,
                    py: 0,
                    color: 'inherit',
                    textTransform: 'none',
                    textDecoration: 'underline',
                    textDecorationStyle: 'dotted',
                    textUnderlineOffset: '3px',
                    '&:hover': {
                        bgcolor: 'transparent',
                        textDecoration: 'underline',
                        textDecorationStyle: 'dotted',
                    },
                    '& .MuiButton-endIcon': { ml: 0.25 },
                }}
            >
                {translate(casesIdTypeLocaleKey(value))}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                onClick={(event) => event.stopPropagation()}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                {CASES_ID_TYPES.map((option) => (
                    <MenuItem
                        key={option}
                        selected={option === value}
                        onClick={() => {
                            setAnchorEl(null);
                            if (option !== value) {
                                onChange(option);
                            }
                        }}
                    >
                        {translate(casesIdTypeLocaleKey(option))}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
